/******************************************************
 *                  Global exploitation Ctrl
 ********************************************************/

"use strict";

angular.module("exploitation")

	.controller("ExploitNetworkLinesCtrl", ["$scope","$location", "OkinaLeafletService", "networks", "companies", "categories", "AdminClientsService", "SecurityService", "ExploitationService", function ($scope,$location, OkinaLeafletService, networks, companies, categories, AdminClientsService, SecurityService, ExploitationService) {
		ExploitationService.updateNetworkCache(networks ? networks.data : []);
		$scope.data = {
			networks: networks ? networks.data : [],
			companies : companies ? companies.data : [],
			categories : categories ? categories.data : [],
			selectedNetwork: {}
		};

		// Centre de la France
		OkinaLeafletService.init("map");
		OkinaLeafletService.setCenter({
			lat: 47.070659,
			lng: 1.3146023,
			zoom: 6
		});
		$scope.LeafletService = OkinaLeafletService;

		async function checkModuleAutorizations() {
			if (SecurityService.hasRight('canAccessTopology')) {
				return true;
			}
			let hasAuthorization = false;
			let client = await AdminClientsService.getCurrentClient();
			if (client != null) {
				let moduleAccessibilityResp = await AdminClientsService.getClientModuleAccessibilitites(client.id);
				if (moduleAccessibilityResp.status === 200 && moduleAccessibilityResp.data) {
					hasAuthorization = moduleAccessibilityResp.data.is_topology_activated;
				}
			}
			return hasAuthorization;

		}

		checkModuleAutorizations().then(hasAuthorization => {
			if (!hasAuthorization) {
				$location.path("/e-iti/perturbations");
			}
		});

	}]);